"use client";

import { Event, Group, Resource, Workspace } from "@/db/schema";
import { useSearchParams } from "next/navigation";
import * as React from "react";
import { useMemo } from "react";
import { ResourceColumn } from "./ResourceColumn";

interface Props {
  resources: Resource[];
  workspace: Workspace;
  from: Date;
  to: Date;
  events: Event[];
  group: Group;
}

export const ResourceCombo: React.FC<Props> = ({
  resources,
  workspace,
  to,
  from,
  events,
  group,
}) => {
  const searchParams = useSearchParams();

  const selectedResource = useMemo(() => {
    const resourceFromParams = searchParams.get("selectedResource");
    return resourceFromParams && resources.some((resource) => resource.id === resourceFromParams)
      ? resourceFromParams
      : resources[0]?.id;
  }, [searchParams, resources]);

  if (!selectedResource) return <p>No resource selected</p>;

  return (
    <div className="">
      <ResourceColumn
        group={group}
        workspace={workspace}
        resource={resources.find((r) => r.id === selectedResource)!}
        resourceIndex={0}
        events={events.filter((e) => e.resourceId === selectedResource)}
        from={from}
        to={to}
        standalone={true}
      />
    </div>
  );
};
